// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitPopOver__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/SearchUnitPopOver/SearchUnitPopOver.scss
 ** module id = 940
 ** module chunks = 1
 **/